export const URL_LOGO_SEALABS =
  "https://raw.githubusercontent.com/sealabscr/public-assets/main/sealabs.cr/logo_sealabs.png";
export const URL_LOGO_SEALABS_WHITE =
  "https://raw.githubusercontent.com/sealabscr/public-assets/main/sealabs.cr/logo_selabs_white.png";
export const URL_LOGO_SEALABS_BLUE =
  "https://raw.githubusercontent.com/sealabscr/public-assets/main/sealabs.cr/logo_selabs_blue.png";
export const URL_LOGO_SEALABS_DARK =
  "https://res.cloudinary.com/sealabs/image/upload/v1664661766/logos/logo_selabs_dark_if4ycw.png";
